import axios from "axios"

import { store } from "../store"

export const getUri = () => {

   // return 'https://apireportes.spring.com.co'

   var url = window.location.host.split('.')

   let domain = (url[0].includes('localhost')) ? 'spring_reports_api.test' : 'apireportes.spring.com.co'

   return `https://${domain}`
}

export const getDomain = () => {
   var uri = getUri()
   
   return `${uri}/api`
}

/*
 * Instancia con el servicio principal del backend
 */
const springReportsApi = () => {
   const state = store.getState();
   const authToken = state.auth.token;

   return axios.create({
      baseURL: getDomain(),
      timeout: 100000,
      headers: {
         Authorization: `Bearer ${authToken}`,
         "Content-Type": "application/json; charset=UTF-8",
      }
   });
};

export default springReportsApi;
